// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"leesItem-module--wrapper--BN9BZ","beeld":"leesItem-module--beeld--hkvDP","info":"leesItem-module--info--24__M"};